import type {ProcedureOption} from 'presentation/pages/private/refund/pages/RequestPreview/components/Procedures/types';
import {makeGetRefundEligibleProcedures} from 'main/factories/usecases';

const DEFAULT_PROCEDURES_PAGE_LIMIT = 3;

export const PROCEDURES_FULL_LIST_LIMIT = 2000;

type ListEligibleProceduresApiResponse = {
	content: {
		procedure: Array<{code: string; description: string}>;
		total: number;
		totalPerPage: number;
		notifications: unknown[];
	};
};

function mapProcedureToOption(code: string, description: string): ProcedureOption {
	return {
		value: code,
		label: description,
		code,
	};
}

export type GetRefundEligibleProceduresPageResult = {
	options: ProcedureOption[];
	hasMore: boolean;
};

export const getRefundEligibleProceduresPage = async (params: {
	page: number;
	limit?: number;
	signal?: AbortSignal;
}): Promise<GetRefundEligibleProceduresPageResult> => {
	const {
		page,
		limit = DEFAULT_PROCEDURES_PAGE_LIMIT,
		signal,
	} = params;
	const data = (await makeGetRefundEligibleProcedures().get({
		limit,
		page,
		signal,
	})) as unknown as ListEligibleProceduresApiResponse;

	const procedures = data?.content?.procedure ?? [];
	const options = procedures.map(p => mapProcedureToOption(p.code, p.description));
	const total = data?.content?.total ?? 0;
	const hasMore = page * limit < total;

	return {options, hasMore};
};
